import script from "./InviteAlumni.vue?vue&type=script&lang=ts&setup=true"
export * from "./InviteAlumni.vue?vue&type=script&lang=ts&setup=true"

import "./InviteAlumni.vue?vue&type=style&index=0&id=0f6206dc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6206dc"]])

export default __exports__